import clsx from 'clsx'
import {
  publishPanel,
  type CommunityPointsTable,
  type CommunityStandingNext,
} from 'lib/community/review'
import base from './community.module.css'
import styles from './Review.module.css'

interface ReviewPublishPanelProps {
  productName: string
  points: CommunityPointsTable | null
  founding: { count: number; cap: number } | null
  publishedCount: number
  standing: CommunityStandingNext | null
  signedIn: boolean
  counts: boolean
  hasPhoto: boolean
  /** The community sign-in gate, for a new review: the sign-in line says now or at Publish.
   *  The button stays — it only opens the dialog, and nothing links before Publish. */
  gated: boolean
  onSignIn: () => Promise<void>
}

/**
 * "When you publish" (design 5b): what this review earns, in DealHunt's figures — the points
 * table from the summary, the founding number and next tier from `/me`. Reader-specific, so
 * the composer renders it only once `/me` has settled; the server HTML never carries it.
 */
const ReviewPublishPanel: React.VFC<ReviewPublishPanelProps> = ({ onSignIn, gated, ...input }) => {
  const panel = publishPanel(input, { gated })
  return (
    <section className={base.card} aria-labelledby="review-publish-title">
      <p id="review-publish-title" className={base.eyebrow}>
        {'When you publish'}
      </p>
      {panel.rows.length > 0 && (
        <ul className={styles.rows}>
          {panel.rows.map(row => (
            <li key={row.id} className={styles.rowItem}>
              <div className={base.row}>
                <span className={styles.rowLabel}>{row.label}</span>
                <span className={clsx(base.rowStrong, styles.rowValue)}>{row.value}</span>
              </div>
              {row.detail && <p className={styles.rowDetail}>{row.detail}</p>}
            </li>
          ))}
        </ul>
      )}
      {panel.capped && (
        <p className={base.hint} role="status">
          {panel.capped}
        </p>
      )}
      {panel.edit && <p className={base.text}>{panel.edit}</p>}
      {panel.signIn && (
        <>
          <p className={base.text}>{panel.signIn}</p>
          <button type="button" className={base.btn} onClick={() => void onSignIn()}>
            {'Sign in'}
          </button>
        </>
      )}
      {panel.owners && <p className={base.fine}>{panel.owners}</p>}
    </section>
  )
}

export default ReviewPublishPanel
